import { createFileRoute, redirect } from '@tanstack/react-router';

import { PaymentSuccessPage } from '@/pages/payments';

type PaymentSuccessSearch = {
  session_id?: string;
};
export const Route = createFileRoute('/_user/payment/success')({
  beforeLoad: async ({ context }) => {
    const user =
      context.auth.user ?? (await context.auth.userRefetch().catch(() => null));

    if (!user) {
      throw redirect({ to: '/sign-in' });
    }
  },
  validateSearch: (search: Record<string, string>): PaymentSuccessSearch => ({
    session_id: search.session_id ? search.session_id : undefined,
  }),
  component: PaymentSuccessPage,
});
